import { RegionZone, Zone } from '@/types';
import React, { HTMLAttributes } from 'react';
import { BadgeDisplay } from './BadgeDisplay';
import { useFocusZone } from '../hooks/useFocusZone';

type ZoneLike = Partial<Zone> | Partial<RegionZone>;

export type ZoneBadgeProps = {
  zone: ZoneLike;
  extraContent?: React.ReactNode | React.ReactNode[];
  style?: React.CSSProperties;
  className?: string;
  showTspName?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const ZoneBadge = ({
  zone,
  extraContent = '',
  style = {},
  className,
  ...props
}: ZoneBadgeProps) => {
  const focusZone = useFocusZone();
  if (!zone) {
    return null;
  }
  return (
    <BadgeDisplay
      style={style}
      role="button"
      className={className}
      {...props}
      onClick={(evt) => {
        focusZone(zone.id);
        props.onClick?.(evt);
      }}
    >
      <span className="me-1">{zone.tsp?.name ? `${zone.tsp?.name}:` : ''}</span>{' '}
      {zone.name}
      <br />
      {extraContent}
    </BadgeDisplay>
  );
};
